/** Nombre de collector sugerido para un alta nueva. Corre con `npm test`. */

/** Mismo algoritmo que collectorNameFrom del onboarding (y createCollectorAr de CoreDB). */
export function suggestedCollectorName(dba: string | undefined): string {
  const map: Record<string, string> = { á: "a", é: "e", í: "i", ó: "o", ú: "u", Á: "A", É: "E", Í: "I", Ó: "O", Ú: "U", ñ: "n", Ñ: "N" };
  let out = ""; let l = 0;
  for (const ch of dba ?? "") {
    l++; if (l > 18) break;
    if (/[A-Za-z0-9_-]/.test(ch)) out += ch; else if (map[ch]) out += map[ch];
  }
  return out;
}
